/* WebComponentLabelPrintingLabelOverviewTsx template */
import { h } from '@stencil/core';

const WebComponentLabelPrintingStandaloneTsx = (context) => {
    let I18N = context.ref.I18N;

    return (
        <dia-grid>
            { /* @ts-ignore */}
            <header backend>
                <dia-grid-content>
                    <dia-flex-container>
                        { I18N.t('Etikettendruck') }
                        { /* @ts-ignore */}
                        <nav headline={ I18N.t('Übersicht') }>
                            { /* @ts-ignore */}
                            <ul main>
                                <li data-active={context.ref.activeOnRoutes([
                                  'ROOT',
                                  'PRINT'
                                ])}>
                                    <a href={context.ref.getRouterRouteHref('ROOT')}>
                                        <i data-dia-icon-before="print"></i>{ I18N.t('Drucken') }
                                    </a>
                                </li>
                                { (context.ref.expertMode && context.ref.expertModeActive)  ?
                                  <li data-active={context.ref.activeOnRoutes([
                                    'LABEL_OVERVIEW',
                                    'LABEL_CREATE'
                                  ])}>
                                    { /* @ts-ignore */}
                                    <input type="checkbox" headline={ I18N.t('Etiketten') } />
                                    <a href={context.ref.getRouterRouteHref('LABEL_OVERVIEW')}>
                                      <i data-dia-icon-before="tags"></i>{ I18N.t('Etiketten') }
                                    </a>
                                    <span>
                                      <ul>
                                          <li data-active={context.ref.activeOnRoutes([
                                            'LABEL_OVERVIEW'
                                          ])}>
                            { /* @ts-ignore */}
                                              <input type="checkbox" headline={ I18N.t('Übersicht') } />
                                              <a href={context.ref.getRouterRouteHref('LABEL_OVERVIEW')}>
                                                  <i data-dia-icon-before="table"></i>{ I18N.t('Übersicht') }
                                              </a>
                                          </li>
                                          <li data-active={context.ref.activeOnRoutes([
                                            'LABEL_CREATE'
                                          ])}>
                            { /* @ts-ignore */}
                                              <input type="checkbox" headline={ I18N.t('Erstellen') } />
                                              <a href={context.ref.getRouterRouteHref('LABEL_CREATE')}>
                                                  <i data-dia-icon-before="plus"></i>{ I18N.t('Erstellen') }
                                              </a>
                                          </li>
                                      </ul>
                                    </span>
                                </li> : ''}
                                { (context.ref.expertMode && context.ref.expertModeActive) ? <li data-active={context.ref.activeOnRoutes([
                                  'PAGE_TEMPLATE_OVERVIEW',
                                  'PAGE_TEMPLATE_CREATE',
                                  'PAGE_TEMPLATE_EDIT'
                                ])}>
                                    { /* @ts-ignore */}
                                    <input type="checkbox" headline={ I18N.t('Druckvorlagen') } />
                                    <a href={context.ref.getRouterRouteHref('PAGE_TEMPLATE_OVERVIEW')}>
                                        <i data-dia-icon-before="sheet"></i>{ I18N.t('Druckvorlagen') }
                                    </a>
                                    <span>
                                      <ul>
                                          <li data-active={context.ref.activeOnRoutes([
                                            'PAGE_TEMPLATE_OVERVIEW'
                                          ])}>
                            { /* @ts-ignore */}
                                              <input type="checkbox" headline={ I18N.t('Übersicht') } />
                                              <a href={context.ref.getRouterRouteHref('PAGE_TEMPLATE_OVERVIEW')}><i
                                                  data-dia-icon-before="table"></i>{ I18N.t('Übersicht') }</a>
                                          </li>
                                          <li data-active={context.ref.activeOnRoutes([
                                            'PAGE_TEMPLATE_CREATE'
                                          ])}>
                            { /* @ts-ignore */}
                                              <input type="checkbox" headline={ I18N.t('Erstellen') } />
                                              <a href={context.ref.getRouterRouteHref('PAGE_TEMPLATE_CREATE')}>
                                                <i data-dia-icon-before="plus"></i>{ I18N.t('Erstellen') }</a>
                                          </li>
                                      </ul>
                                    </span>
                                </li> : ''}
                                {context.ref.expertModeVisible ? <li data-expert>
                                    <dia-switch>
                                        <input type="checkbox" id="switch" onChange={(event) => context.ref.toggleExpertMode(event)} checked={context.ref.expertModeActive} />
                                        <label htmlFor="switch">{ I18N.t('Toggle') }</label>
                                    </dia-switch>
                                    <i data-dia-icon-before="expert"></i>
                                    { I18N.t('Experten-Modus') }
                                </li> : ''}
                                <li data-close>
                                    { /* @ts-ignore */}
                                    <a onClick={(e) => context.ref.close(e)}>
                                        <i data-dia-icon-before="close"></i>
                                    </a>
                                </li>
                            </ul>
                            <input type="checkbox"/>
                        </nav>
                    </dia-flex-container>
                </dia-grid-content>
            </header>
            <dia-breadcrumb>
                <nav aria-label="Breadcrumb">
                    <ul>
                        <li>
                            <i data-dia-icon-before={context.ref.panelHeaderIcon}></i>
                            {context.ref.panelHeaderTitle}
                        </li>
                    </ul>
                </nav>
            </dia-breadcrumb>
            <main>
                <article>
                    <section>
                        {context.content}
                    </section>
                </article>
            </main>
        </dia-grid>
    )
};

export default WebComponentLabelPrintingStandaloneTsx;

